import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import { validatorRequire } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    domainID: {
      type: Select,
      props: {
        caption: 'common.domain',
        valueField: 'id',
        labelField: 'name',
        loading: vue.$store.getters['domain/isLoading'],
        options: vue.$store.getters['domain/loadedItems'],
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    code: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 16,
        required: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  return form;
}
